import { QuantityType } from "../../../graphql/generated";
import i18next from "i18next";
import enumLabel from "../enumLabel";

const quantityTypeLabel = (type: QuantityType) => {
  const labels: Record<QuantityType, string> = {
    [QuantityType.Ordered]: "Ordered",
    [QuantityType.Loaded]: "Loaded",
    [QuantityType.Delivered]: "Delivered",
  };

  return i18next.t(
    `billingRules:quantityType.${type}`,
    labels[type] || enumLabel(type) || type
  ) as string;
};

export default quantityTypeLabel;
